import { render, staticRenderFns } from "./user-alert.vue?vue&type=template&id=42e3bc18&"
import script from "./user-alert.vue?vue&type=script&lang=ts&"
export * from "./user-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports